export const personKeys = {
  get: () => ['person'] as const,
};
